import React, { useEffect, useLayoutEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const STEPS = [
  { target: null, title: 'Quick tour', text: 'Six short steps covering the main areas. You can start it again from the compass icon in the top bar.' },
  { target: '[data-tour=nav]', title: 'Navigation', text: 'Greenhouses and stations, alerts, the live data console, and analytics.' },
  { target: '[data-tour=live]', title: 'Live connection', text: 'Shows whether readings are arriving in real time and how many came in during the last minute. It reconnects on its own if the link drops.' },
  { target: '[data-tour=kpis]', title: 'Key figures', text: 'Hover the info icons to see what each figure means.' },
  { target: '[data-tour=map]', title: 'Station map', text: 'Each marker is a station showing its latest value. The colour reflects its status. Click a marker to open its greenhouse.' },
  { target: '[data-tour=search]', title: 'Search', text: 'Ctrl+K (or ⌘K) searches greenhouses, stations and pages, and can switch the theme.' },
];

export default function Tour({ open, onClose }) {
  const [i, setI] = useState(0);
  const [rect, setRect] = useState(null);
  const nav = useNavigate();
  const step = STEPS[i];

  useEffect(() => { if (open) { setI(0); nav('/'); } }, [open]); // eslint-disable-line react-hooks/exhaustive-deps

  useLayoutEffect(() => {
    if (!open) return undefined;
    const measure = () => {
      const el = step.target && document.querySelector(step.target);
      if (!el) return setRect(null);
      el.scrollIntoView({ block: 'center', behavior: 'smooth' });
      const r = el.getBoundingClientRect();
      setRect({ x: r.left - 8, y: r.top - 8, w: r.width + 16, h: r.height + 16 });
    };
    const t = setTimeout(measure, 350);
    window.addEventListener('resize', measure);
    return () => { clearTimeout(t); window.removeEventListener('resize', measure); };
  }, [open, i, step.target]);

  if (!open) return null;
  const last = i === STEPS.length - 1;
  const pw = Math.min(340, window.innerWidth - 24);
  let style = { left: Math.max(12, (window.innerWidth - pw) / 2), top: Math.max(12, window.innerHeight / 2 - 120) };
  if (rect) {
    const below = rect.y + rect.h + 14 + 190 < window.innerHeight;
    style = { left: Math.min(Math.max(12, rect.x), window.innerWidth - pw - 12), top: below ? rect.y + rect.h + 14 : Math.max(12, rect.y - 200) };
  }
  return (
    <>
      <div className="tour-mask" onClick={onClose} />
      {rect ? <div className="tour-hole" style={{ left: rect.x, top: rect.y, width: rect.w, height: rect.h }} /> : <div className="overlay" style={{ zIndex: 110 }} />}
      <div className="tour-pop" style={style} role="dialog" aria-label="Guided tour">
        <h3>{step.title}</h3>
        <p>{step.text}</p>
        <div className="row between" style={{ marginTop: 14 }}>
          <div className="tour-dots">{STEPS.map((_, n) => <i key={n} className={n === i ? 'on' : ''} />)}</div>
          <div className="row" style={{ gap: 6 }}>
            <button className="btn ghost sm" onClick={onClose}>Skip</button>
            {i > 0 && <button className="btn sm" onClick={() => setI(i - 1)}>Back</button>}
            <button className="btn primary sm" onClick={() => (last ? onClose() : setI(i + 1))}>{last ? 'Done' : 'Next'}</button>
          </div>
        </div>
      </div>
    </>
  );
}
